<template>
	<div class="main-top">
		<home-nav></home-nav>

		<!-- Trazilica banner -->
		<section id="uvjeti-banner" class="uvjeti-banner-area">
			<div class="overlay overlay-bg"></div>
			<div class="container">
				<div class="row align-items-center justify-content-between">
					<div class="col-12 uvjeti-banner-content">
						<div class="row">
							<div class="col-12">
								<h1 class="text-center">Česta pitanja</h1>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>


		<section class="my-5">
			<div class="container">
				<div class="row">
					<div class="col-md-12 text-justify">
						<p><b>Što je Figaro.hr</b><br>
							Figaro.hr je besplatan servis za naručivanje termina u salonima za zadravlje i ljepotu koji ti omogućuje da pronađeš najbolje za sebe. Usporedi cijene, pogledaj ocijene i komentare drugih korisnika i naručuj termine u svojim omiljenim salonima.</p>

						<p><b>Kako mogu rezervirati termin putem Figaro.hr?</b><br>
							Nakon uspješne registracije, pretražite salone i usluge, odaberite uslugu koju želite rezervirati ili više njih i slijedite korake rezervacije.</p>

						<p><b>Zašto je za rezerviranje potrebna registracija?</b><br>
							Registracija je potrebna jer prilikom nje unosite podatke koji su potrebni salonima kako bi dobili informacije o naručitelju usluga. Nakon toga, uneseni podaci ostaju zapamćeni pa ih nije potrebno svaki puta iznova upisivati.</p>

						<p><b>Koji su koraci rezerviranja?</b><br>
							Nakon što pronađete salon i uslugu koju želite rezervirati, pritiskom na dugme "BOOK" otvoriti će vam se prozorčić u kojem trebate redom odabrati djelatnika, datum i vrijeme pružanja usluge.</p>

						<p><b>Što ako želim rezervirati više usluga odjednom?</b><br>
							U prozorčiću za rezervacije postoji opcija "dodaj usluge" koja vam omogućuje da dodate usluge koje ODABRANI DJELATNIK pruža.</p>

						<p><b>Što ako imam napomenu koju želim poslati salonu?</b><br>
							Napomena je također opcija koju možete iskoristiti prilikom naručivanja termina ali nije obavezna za izvršenje rezervacije.</p>

						<p><b>Što ako želim otkazati svoju rezervaciju?</b><br>
							Ako želite otkazati svoju rezervaciju to možete učiniti tako da u svom korisničkom sučelju, u dijelu "Moje rezervacije" pronađete željenu rezervaciju i otkažete ju.</p>

						<p><b>Kako mogu znati je li moja rezervacija prihvaćena?</b><br>
							Primit ćeš e-mail koji potvrđuje da je tvoj upit za rezervaciju poslan salonu. Nakon što salon potvrdi ili odbije tvoj zahtjev za rezervaciju također češ dobiti obavijest na svoj e-mail.</p>

						<p><b>Što ako se ne pojavim u dogovoreno vrijeme?</b><br>
							Ako ne dođete u dogovoreno vrijeme, salon ima opciju da vaš termin označi kao nedolazak. Nedolasci se evidentiraju i prilikom svakog naručivanja termina svi saloni imaju uvid u njih.</p>

						<p><b>Kako mogu platiti naručene usluge salonu?</b><br>
							Plaćanje naručenih usluga odvija se isključivo u salonu nakon pružanja usluge. Prihvatljivi oblici plaćanja ovise isključivo o salonu i isti su istaknuti na stranici salona.</p>

						<p><b>Mogu li komentirati i dati ocjenu salonu?</b><br>
							Naravno! Komentirati i ocijeniti salon moguće je nakon što je vaš tretman završio. Administratori figaro.hr zadržavaju pravo da izbrišu svaki komentar koji smatraju neprimjerenim.</p>
					</div>
				</div>
			</div>
		</section>


		<home-footer></home-footer>
	</div>
</template>
<script>
	export default {
		name: 'home',
	}

</script>
